<template>
  <div class="app-pagination-footer">
    <span class="text-muted">
      Showing {{ meta.from }} to {{ meta.to }} of {{ meta.of }} entries
    </span>

    <b-pagination
      :value="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      first-number
      last-number
      class="mb-0"
      prev-class="prev-item"
      next-class="next-item"
      @input="$emit('update:currentPage', $event)"
    >
      <template #prev-text>
        <feather-icon
          icon="ChevronLeftIcon"
          size="18"
        />
      </template>
      <template #next-text>
        <feather-icon
          icon="ChevronRightIcon"
          size="18"
        />
      </template>
    </b-pagination>
  </div>
</template>

<script>
import { BPagination } from 'bootstrap-vue'

export default {
  name: 'AppPaginationFooter',
  components: {
    BPagination,
  },
  props: {
    meta: {
      type: Object,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    totalRows: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-pagination-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-top: 1px solid rgba(34, 41, 47, .08);
}

@media (max-width: 767.98px) {
  .app-pagination-footer {
    align-items: center;
    flex-direction: column;
    text-align: center;
  }
}
</style>
